export default __webpack_public_path__ + "static/media/restaurant.8ee16253.jpg";